module.exports = __webpack_public_path__ + "static/media/19.94760405.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/19.png
// module id = 1516
// module chunks = 0